import { render, staticRenderFns } from "./StarsRating.vue?vue&type=template&id=28bb3110&scoped=true&"
import script from "./StarsRating.vue?vue&type=script&lang=ts&"
export * from "./StarsRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb3110",
  null
  
)

export default component.exports